"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../core/utils");

var SelloutReleaseSnapshot_1 = require("../../model/sellout/SelloutReleaseSnapshot");

var SelloutReleaseSnapshotConverter_1 = require("./SelloutReleaseSnapshotConverter");

var SelloutReleaseSnapshotConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseSnapsh) {
  _inherits(SelloutReleaseSnapshotConverterImpl, _SelloutReleaseSnapsh);

  function SelloutReleaseSnapshotConverterImpl() {
    _classCallCheck(this, SelloutReleaseSnapshotConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseSnapshotConverterImpl).call(this));
  }

  _createClass(SelloutReleaseSnapshotConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutReleaseSnapshot_1.SelloutReleaseSnapshot(SelloutReleaseSnapshot_1.SelloutReleaseSnapshot.schema.snapshotTime.valueOfField(source), SelloutReleaseSnapshot_1.SelloutReleaseSnapshot.schema.priceValidityStartDate.valueOfField(source), utils_1.Utils.isValueMissing(source.endDate) ? null : conversions.toDate(source.endDate), utils_1.Utils.isValueMissing(source.minPriceChangeInPercent) ? null : conversions.toBigNumber(source.minPriceChangeInPercent), utils_1.Utils.isValueMissing(source.maxPriceChangeInPercent) ? null : conversions.toBigNumber(source.maxPriceChangeInPercent), utils_1.Utils.isValueMissing(source.minMarginChangeInPercent) ? null : conversions.toBigNumber(source.minMarginChangeInPercent), SelloutReleaseSnapshot_1.SelloutReleaseSnapshot.schema.repricingEstimationThreshold.valueOfField(source));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        snapshotTime: conversions.fromDate(source.snapshotTime),
        priceValidityStartDate: source.priceValidityStartDate !== null ? conversions.fromDate(source.priceValidityStartDate) : null,
        endDate: source.endDate !== null ? conversions.fromDate(source.endDate) : null,
        minPriceChangeInPercent: source.minPriceChangeInPercent !== null ? conversions.fromBigNumber(source.minPriceChangeInPercent) : null,
        maxPriceChangeInPercent: source.maxPriceChangeInPercent !== null ? conversions.fromBigNumber(source.maxPriceChangeInPercent) : null,
        minMarginChangeInPercent: source.minMarginChangeInPercent !== null ? conversions.fromBigNumber(source.minMarginChangeInPercent) : null,
        repricingEstimationThreshold: source.repricingEstimationThreshold
      };
    }
  }]);

  return SelloutReleaseSnapshotConverterImpl;
}(SelloutReleaseSnapshotConverter_1.SelloutReleaseSnapshotConverter);

exports.SelloutReleaseSnapshotConverterImpl = SelloutReleaseSnapshotConverterImpl;